export const GODAR_REQUEST_URL = "http://8.130.187.17:8080/ruoyi-godar/godar";

export const REQUEST_URL = "http://8.130.187.17/webapi";
